import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";
import { BlockScrollStrategy } from "@angular/cdk/overlay";

@Injectable({
    providedIn:"root"
})
export class ConfirmService{
    private _confirmSource: Subject<boolean> = new Subject<boolean>();
    private _closeDialogSource: Subject<boolean> = new Subject<boolean>();
    confirm$ : Observable<boolean> = this._confirmSource.asObservable();
    closeDialog$: Observable<boolean> = this._closeDialogSource.asObservable();

    constructor(){
    }

    confirm()
    {
        this._confirmSource.next(true);
    }
    closeDialog()
    {
        this._closeDialogSource.next(true);
    }

}